module.exports = __webpack_public_path__ + "img/programa-interna.e9becce1.png";